<template>
    <div>
        <dx-grid
            :url="url"
            :columns="columns"
            :actions="actions"
            :title="title"
            :onRowClicked="onRowClicked"
            navigationPath="onRowClicked"
            navigationField="onRowClicked"
            :beforeSetupGrid="beforeSetupGrid"
            :selectionEnabled="true"
            ref="grid"
        ></dx-grid>

        <v-dialog persistent v-model="addNewRouteDialog" max-width="1000">
            <v-card class="pa-3">
                <v-card-title class="headline pl-1 pt-0"
                    >New Route - Season: {{ newRoute.season }}</v-card-title
                >

                <v-layout row>
                    <v-layout column xs6 class="pr-2" style="min-width: 50%">
                        <v-text-field
                            class="mx-2 mb-2"
                            v-model="newRoute.description"
                            label="Description"
                            ref="newDescription"
                            :rules="[rules.required]"
                        ></v-text-field>
                        <v-select
                            class="mx-2 mb-2"
                            v-model="newRoute.direction"
                            label="Direction"
                            ref="newDirection"
                            :rules="[rules.required]"
                            :items="['Pickup', 'Dropoff']"
                        ></v-select>
                        <v-select
                            class="mx-2 mb-2"
                            v-model="newRoute.buildings"
                            label="Buildings"
                            ref="newBuildings"
                            :items="buildingList"
                            multiple
                            :rules="[rules.required]"
                            :menu-props="{ closeOnContentClick: true }"
                        ></v-select>
                        <v-select
                            class="mx-2 mb-2"
                            v-model="newRoute.grades"
                            label="Grades"
                            ref="newGrades"
                            :items="gradeList"
                            multiple
                            :rules="[rules.required]"
                        ></v-select>
                        <v-select
                            class="mx-2 mb-2"
                            v-model="newRoute.weekDays"
                            label="Weekdays"
                            ref="newWeekdays"
                            :items="weekDayList"
                            multiple
                        ></v-select>

                        <!-- <v-select
                            class="mx-2 mb-2"
                            v-model="newRoute.term"
                            label="Term"
                            ref="newTerm"
                            :items="terms"
                            :rules="[rules.required]"
                        ></v-select> -->
                        <v-layout row class="mb-2">
                            <div class="font-weight-regular ml-2 pt-2 pb-1">
                                Time Start:
                            </div>
                            <DxDateBox
                                type="time"
                                picker-type="list"
                                :interval="12"
                                class="mx-2 mb-0"
                                v-model="newRoute.timeStart"
                                :rules="[rules.required]"
                            />
                        </v-layout>

                        <v-text-field
                            class="mx-2 mb-0"
                            v-model="newRoute.notes"
                            label="Notes"
                            ref="notes"
                        ></v-text-field>
                        <v-text-field
                            class="mx-2 mb-0"
                            v-model="newRoute.color"
                            label="Color"
                            ref="color"
                        ></v-text-field>
                        <v-layout row>
                            <v-text-field
                                class="mx-2 mb-0"
                                v-model="newRoute.routeIdentifier"
                                label="Route Identifier"
                                ref="newRouteIdentifier"
                                :rules="[rules.required]"
                            ></v-text-field>
                            <v-select
                                class="mx-2 mb-0"
                                v-model="newRoute.groupBy"
                                label="Group"
                                ref="newGroupBy"
                                :rules="[rules.required]"
                                :items="['AM', 'PM', 'CUSTOM', 'FAM', 'PPM']"
                            ></v-select>
                        </v-layout>
                        <v-checkbox
                            v-model="newRoute.goeNotRequired"
                            class="mx-2 mt-0"
                            label="GOE Not Required"
                            color="success"
                            hide-details
                        ></v-checkbox>
                    </v-layout>
                    <v-layout column xs6 class="pl-2" style="min-width: 50%">
                        <div
                            v-for="(routeSchedule,
                            index) in newRoute.routeSchedules"
                        >
                            <v-layout row align-center>
                                <v-layout column class="mr-2">
                                    <v-layout row>
                                        <v-select
                                            class="mx-1"
                                            label="Driver / Bus"
                                            v-model="routeSchedule.driver_bus"
                                            :items="
                                                driver_busList.map(
                                                    (b) => b.displayName,
                                                )
                                            "
                                            ref="newRouteDriver_bus"
                                            :rules="[
                                                (value) =>
                                                    rules.busDriverRequired(
                                                        value,
                                                        routeSchedule,
                                                    ),
                                            ]"
                                        ></v-select>
                                        <!-- <v-btn-toggle
                                            mandatory
                                            v-model="routeSchedule.type"
                                            class="toggle-button-group ml-2 mt-3"
                                            style="height: 29px;"
                                        >
                                            <v-btn
                                                flat
                                                value="Default"
                                                class="toggle-button default-schedule-button"
                                            >
                                                Default
                                            </v-btn>
                                            <v-btn
                                                flat
                                                value="Sub"
                                                class="toggle-button sub-schedule-button"
                                            >
                                                Sub
                                            </v-btn>
                                        </v-btn-toggle> -->
                                    </v-layout>
                                    <v-layout row>
                                        <v-menu
                                            v-model="
                                                routeSchedule.dateFromPickerMenu
                                            "
                                            :close-on-content-click="true"
                                            offset-y
                                            full-width
                                            prepend-icon="mdi-currency-usd"
                                        >
                                            <template v-slot:activator="{ on }">
                                                <v-text-field
                                                    v-model="
                                                        routeSchedule.dateFrom
                                                    "
                                                    :value="
                                                        formatedDate(
                                                            routeSchedule.dateFrom,
                                                        )
                                                    "
                                                    label="From Date"
                                                    prepend-icon="mdi-calendar"
                                                    v-on="on"
                                                    clearable
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker
                                                v-model="routeSchedule.dateFrom"
                                            ></v-date-picker>
                                        </v-menu>
                                        <v-menu
                                            v-model="
                                                routeSchedule.dateToPickerMenu
                                            "
                                            :close-on-content-click="true"
                                            offset-y
                                            full-width
                                            prepend-icon="mdi-currency-usd"
                                        >
                                            <template v-slot:activator="{ on }">
                                                <v-text-field
                                                    v-model="
                                                        routeSchedule.dateTo
                                                    "
                                                    :value="
                                                        formatedDate(
                                                            routeSchedule.dateTo,
                                                        )
                                                    "
                                                    label="To Date"
                                                    prepend-icon="mdi-calendar"
                                                    v-on="on"
                                                    clearable
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker
                                                v-model="routeSchedule.dateTo"
                                            ></v-date-picker>
                                        </v-menu>
                                    </v-layout>
                                    <v-select
                                        class="mb-2 mx-1"
                                        v-model="routeSchedule.term"
                                        label="Term"
                                        ref="routeScheduleTerm"
                                        :items="terms"
                                        :rules="[rules.required]"
                                    ></v-select>
                                </v-layout>

                                <!-- <v-btn
                                    class="pt-0 mt-0"
                                    @click.stop="addRouteSchedule"
                                    flat
                                    icon
                                    color="success"
                                >
                                    <v-icon>mdi-plus-circle</v-icon>
                                </v-btn>
                                <v-btn
                                    class="pt-0 mt-0"
                                    @click.stop="removeRouteSchedule(index)"
                                    flat
                                    icon
                                    color="#f55a4e"
                                >
                                    <v-icon>mdi-minus-circle-outline</v-icon>
                                </v-btn> -->
                            </v-layout>
                        </div>
                    </v-layout>
                </v-layout>

                <v-card-actions class="mx-0 pt-3 px-2 pb-2 mt-3">
                    <v-spacer></v-spacer>
                    <v-btn color="default" dark @click="closeAddRouteDialog()"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="saveNewRoute()"
                    >
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog persistent v-model="updateRouteDialog" max-width="1000">
            <update-route
                ref="updateRouteDialog"
                :rowClicked="rowClicked"
                :driver_busList="driver_busList"
                :loadRouteSchedules="loadRouteSchedules"
                :reloadGrid="reloadGrid"
                :terms="terms"
                :buildingList="buildingList"
                :gradeList="gradeList"
                :closeUpdateRouteDialog="closeUpdateRouteDialog"
            ></update-route>
        </v-dialog>

        <v-dialog persistent v-model="updateGroupAndIdDialog" max-width="400">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0"
                    >Update Group & ID</v-card-title
                >
                <v-text-field
                    class="mb-0"
                    v-model="routeIdentifier"
                    label="Route Identifier"
                    ref="routeIdentifier"
                    :rules="[rules.required]"
                ></v-text-field>
                <v-select
                    class="mb-0"
                    v-model="groupBy"
                    label="Group"
                    ref="groupBy"
                    :rules="[rules.required]"
                    :items="['AM', 'PM', 'CUSTOM', 'FAM', 'PPM']"
                ></v-select>
                <v-card-actions class="mx-0 pr-0 pb-2 mt-2">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="updateGroupAndIdDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="saveGroupAndID"
                    >
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog persistent v-model="routeScheduleEditDialog" max-width="400">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0"
                    >Update Route Schedule</v-card-title
                >
                <v-select
                    class="mx-1"
                    label="Driver / Bus"
                    v-model="routeScheduleToEdit.driver_bus"
                    :items="driver_busList.map((b) => b.displayName)"
                    ref="driver_bus"
                    :rules="[
                        (value) =>
                            rules.busDriverRequired(value, routeScheduleToEdit),
                    ]"
                ></v-select>
                <v-menu
                    v-model="routeScheduleToEdit.dateFromPickerMenu"
                    :close-on-content-click="true"
                    offset-y
                    full-width
                    prepend-icon="mdi-currency-usd"
                >
                    <template v-slot:activator="{ on }">
                        <v-text-field
                            v-model="routeScheduleToEdit.dateFrom"
                            :value="formatedDate(routeScheduleToEdit.dateFrom)"
                            label="Start Date"
                            prepend-icon="mdi-calendar"
                            clearable
                            v-on="on"
                        ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="routeScheduleToEdit.dateFrom"
                    ></v-date-picker>
                </v-menu>
                <v-menu
                    v-model="routeScheduleToEdit.dateToPickerMenu"
                    :close-on-content-click="true"
                    offset-y
                    full-width
                    prepend-icon="mdi-currency-usd"
                >
                    <template v-slot:activator="{ on }">
                        <v-text-field
                            v-model="routeScheduleToEdit.dateTo"
                            :value="formatedDate(routeScheduleToEdit.dateTo)"
                            label="End Date"
                            prepend-icon="mdi-calendar"
                            clearable
                            v-on="on"
                        ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="routeScheduleToEdit.dateTo"
                    ></v-date-picker>
                </v-menu>
                <v-select
                    class="mb-2"
                    v-model="routeScheduleToEdit.term"
                    label="Term"
                    ref="routeScheduleTerm"
                    :items="terms"
                    :rules="[rules.required]"
                ></v-select>
                <v-card-actions class="mx-0 pr-0 pb-2 mt-2">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="routeScheduleEditDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="
                            saveRouteSchedule({
                                routeSchedule: routeScheduleToEdit,
                            })
                        "
                    >
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card></v-dialog
        >

        <v-dialog persistent v-model="addRouteScheduleDialog" max-width="400">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0"
                    >Add Route Schedule</v-card-title
                >
                <v-select
                    class="mx-1"
                    label="Driver / Bus"
                    v-model="routeScheduleToAdd.driver_bus"
                    :items="driver_busList.map((b) => b.displayName)"
                    ref="driver_bus"
                    :rules="[
                        (value) =>
                            rules.busDriverRequired(value, routeScheduleToAdd),
                    ]"
                ></v-select>
                <v-menu
                    v-model="routeScheduleToAdd.dateFromPickerMenu"
                    :close-on-content-click="true"
                    offset-y
                    full-width
                    prepend-icon="mdi-currency-usd"
                >
                    <template v-slot:activator="{ on }">
                        <v-text-field
                            v-model="routeScheduleToAdd.dateFrom"
                            :value="formatedDate(routeScheduleToAdd.dateFrom)"
                            label="Start Date"
                            prepend-icon="mdi-calendar"
                            clearable
                            v-on="on"
                        ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="routeScheduleToAdd.dateFrom"
                    ></v-date-picker>
                </v-menu>
                <v-menu
                    v-model="routeScheduleToAdd.dateToPickerMenu"
                    :close-on-content-click="true"
                    offset-y
                    full-width
                    prepend-icon="mdi-currency-usd"
                >
                    <template v-slot:activator="{ on }">
                        <v-text-field
                            v-model="routeScheduleToAdd.dateTo"
                            :value="formatedDate(routeScheduleToAdd.dateTo)"
                            label="End Date"
                            prepend-icon="mdi-calendar"
                            clearable
                            v-on="on"
                        ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="routeScheduleToAdd.dateTo"
                    ></v-date-picker>
                </v-menu>
                <v-select
                    class="mb-2"
                    v-model="routeScheduleToAdd.term"
                    label="Term"
                    ref="routeScheduleTerm"
                    :items="terms"
                    :rules="[rules.required]"
                ></v-select>
                <v-card-actions class="mx-0 pr-0 pb-2 mt-2">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="addRouteScheduleDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="
                            saveRouteSchedule({
                                routeSchedule: routeScheduleToAdd,
                            })
                        "
                    >
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card></v-dialog
        >

        <v-dialog
            persistent
            v-model="routeScheduleDeleteDialog"
            max-width="400"
        >
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0"
                    >Delete Route Schedule</v-card-title
                >

                <div
                    class="pa-2 mb-2"
                    style="border: #5cb860 1px solid; border-radius: 5px;"
                >
                    <v-layout row class="mb-2">
                        <div class="font-weight-medium mr-2 pt-2">
                            Driver Bus:
                        </div>
                        <div class="pt-2">
                            {{ routeScheduleToDelete.driver_bus }}
                        </div>
                    </v-layout>
                    <v-layout row class="mb-2">
                        <div class="font-weight-medium mr-2">
                            Start Date:
                        </div>
                        <div>
                            {{ routeScheduleToDelete.dateFrom }}
                        </div> </v-layout
                    ><v-layout row class="mb-2">
                        <div class="font-weight-medium mr-2">
                            End Date:
                        </div>
                        <div>
                            {{ routeScheduleToDelete.dateTo }}
                        </div> </v-layout
                    ><v-layout row class="mb-2">
                        <div class="font-weight-medium mr-2">
                            Term:
                        </div>
                        <div>{{ routeScheduleToDelete.term }}</div>
                    </v-layout>
                </div>

                <v-card-actions class="mr-0 mt-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="routeScheduleDeleteDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="deleteRouteSchedule"
                    >
                        Delete
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog persistent v-model="deleteDialog" max-width="400">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0"
                    >Delete Routes</v-card-title
                >
                <div class="font-weight-regular">
                    The {{ selected.length }} selected routes will be deleted
                </div>
                <v-card-actions class="mr-0 mt-3">
                    <v-spacer></v-spacer>
                    <v-btn color="default" dark @click="deleteDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="deleteRoutes"
                    >
                        Delete
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
            persistent
            v-model="addRouteSchedulesInBulkDialog"
            max-width="400"
        >
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0"
                    >Add Route Schedule</v-card-title
                >
                <v-select
                    class="mx-1"
                    label="Driver / Bus"
                    v-model="addRouteSchedulesInBulk.driver_bus"
                    :items="driver_busList.map((b) => b.displayName)"
                    ref="driver_bus"
                    :rules="[
                        (value) =>
                            rules.busDriverRequired(
                                value,
                                addRouteSchedulesInBulk,
                            ),
                    ]"
                ></v-select>
                <v-menu
                    v-model="addRouteSchedulesInBulk.dateFromPickerMenu"
                    :close-on-content-click="true"
                    offset-y
                    full-width
                    prepend-icon="mdi-currency-usd"
                >
                    <template v-slot:activator="{ on }">
                        <v-text-field
                            v-model="addRouteSchedulesInBulk.dateFrom"
                            :value="
                                formatedDate(addRouteSchedulesInBulk.dateFrom)
                            "
                            label="Start Date"
                            prepend-icon="mdi-calendar"
                            clearable
                            v-on="on"
                        ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="addRouteSchedulesInBulk.dateFrom"
                    ></v-date-picker>
                </v-menu>
                <v-menu
                    v-model="addRouteSchedulesInBulk.dateToPickerMenu"
                    :close-on-content-click="true"
                    offset-y
                    full-width
                    prepend-icon="mdi-currency-usd"
                >
                    <template v-slot:activator="{ on }">
                        <v-text-field
                            v-model="addRouteSchedulesInBulk.dateTo"
                            :value="
                                formatedDate(addRouteSchedulesInBulk.dateTo)
                            "
                            label="End Date"
                            prepend-icon="mdi-calendar"
                            clearable
                            v-on="on"
                        ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="addRouteSchedulesInBulk.dateTo"
                    ></v-date-picker>
                </v-menu>
                <v-select
                    class="mb-2"
                    v-model="addRouteSchedulesInBulk.term"
                    label="Term"
                    ref="routeScheduleTerm"
                    :items="terms"
                    :rules="[rules.required]"
                ></v-select>
                <v-card-actions class="mx-0 pr-0 pb-2 mt-2">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="addRouteSchedulesInBulkDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="saveRouteSchedulesInBulk"
                    >
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card></v-dialog
        >

        <!-- <div v-if="updatingRoute">
            <update-route
                ref="updateRouteDialog"
                :rowClicked="rowClicked"
                :driver_busList="driver_busList"
                :loadRouteSchedules="loadRouteSchedules"
                :reloadGrid="reloadGrid"
            ></update-route>
        </div> -->

        <v-dialog persistent v-model="copyRoutesDialog" max-width="1250">
            <copy-season-routes
                :routes="selected"
                :reload="reloadGrid"
                :closeDialog="closeCopyRoutesDialog"
                :seasons="seasons"
                :selectedSeason="season"
                :terms="terms"
                :selectedTerm="regID"
            ></copy-season-routes>
        </v-dialog>
    </div>
</template>
<script>
import moment from "moment";
import AWS from "aws-sdk";
import DxDateBox from "devextreme-vue/date-box";
import { toISOLocal } from "../../utils/helpers.js";
import UpdateRoute from "./UpdateRoute.vue";
import CopySeasonRoutes from "./CopySeasonRoutes.vue";

export default {
    components: {
        DxDateBox,
        UpdateRoute,
        CopySeasonRoutes,
    },
    data: () => ({
        title: "Routes",

        actions: [],

        updateRouteDialog: false,
        addNewRouteDialog: false,

        updatingRoute: false,

        routeScheduleToAdd: {
            driver_bus: "",
            type: "Default",
            dateFromPickerMenu: false,
            dateFrom: "",
            dateToPickerMenu: false,
            dateTo: "",
            term: "",
        },

        routeScheduleToEdit: {},
        routeScheduleToDelete: {},
        routeScheduleEditDialog: false,
        routeScheduleDeleteDialog: false,
        addRouteScheduleDialog: false,
        addRouteSchedulesInBulkDialog: false,
        addRouteSchedulesInBulk: {
            type: "Default",
            driver_bus: "",
            dateFromPickerMenu: false,
            dateFrom: "",
            dateToPickerMenu: false,
            dateTo: "",
            term: "",
        },

        buildingList: [],
        gradeList: [],
        driver_busList: [],
        weekDayList: [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
        ],

        rowClicked: {
            id: "",
            term: "",
            timeStart: "",
            direction: "",
            buildings: [],
            grades: [],
            description: "",
            color: "",
            notes: "",
            weekDays: [],
            routeSchedules: [],
            routeIdentifier: "",
            groupBy: "",
            goeNotRequired: false,
        },

        newRoute: {
            id: "",
            term: "",
            timeStart: "",
            direction: "",
            color: "",
            notes: "",
            buildings: [],
            grades: [],
            description: "",
            weekDays: [],
            routeSchedules: [],
            routeIdentifier: "",
            groupBy: "",
            goeNotRequired: false,
            season: "",
        },

        processing: false,
        deleteDialog: false,
        deleting: false,
        selected: [],
        files: [],
        url: "",
        terms: [],
        currentRegID: "",
        regID: "",
        seasons: [],
        season: "",

        routeIdentifier: "",
        groupBy: "",
        updateGroupAndIdDialog: false,
        copyRoutesDialog: false,

        copyTo: {
            // season: "",
            // term: "",
            // type: "Default",
            // dateFromPickerMenu: false,
            // dateFrom: "",
            // dateToPickerMenu: false,
            // dateTo: "",
            schedules: [],
        },

        filterForToday: false,

        rules: {
            required: (value) => !!value || "Required.",
            phoneNumber: (v) => {
                return (
                    !v ||
                    ([10, 11].includes(v.replace(/-/g, "").length) &&
                        /^\d+$/.test(v.replace(/-/g, ""))) ||
                    "Invalid Phone Number"
                );
            },
            busDriverRequired: (value, routeSchedule) => {
                return (
                    !routeSchedule.dateFrom ||
                    !routeSchedule.dateTo ||
                    !routeSchedule.type ||
                    !!value ||
                    "Required."
                );
            },
            routeScheduleTypeRequired: (value, routeSchedule) => {
                return (
                    !routeSchedule.dateFrom ||
                    !routeSchedule.dateFrom ||
                    !routeSchedule.driver_bus ||
                    !!value ||
                    "Required."
                );
            },
        },

        columns: [
            // {
            //     label: "ID",
            //     field: "id",
            //     visible: true,
            //     filterValues: [],
            //     filterValue: null,
            //     selectedFilterOperation: null,
            // },
            {
                label: "Description",
                field: "description",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Term",
                field: "term",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Time Start",
                field: "timeStart",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
                calculateSortValue: function(rowData) {
                    return rowData.timeStartSort;
                },
            },
            {
                label: "Direction",
                field: "direction",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Buildings",
                field: "buildings",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Grades",
                field: "grades",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Week Days",
                field: "weekDays",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Driver",
                field: "driver",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Bus Number",
                field: "busNumber",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Color",
                field: "color",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Notes",
                field: "notes",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Route Identifier",
                field: "routeIdentifier",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Group",
                field: "groupBy",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Date From",
                field: "dateFrom",
                visible: true,
                type: "date",
                format: "MM/dd/yyyy",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Date To",
                field: "dateTo",
                visible: true,
                type: "date",
                format: "MM/dd/yyyy",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "GOE Not Required",
                field: "goeNotRequired",
                type: "boolean",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
        ],
    }),
    mounted() {},
    beforeDestroy() {},
    async created() {
        this.loadBuildings();
        this.loadGrades();
        this.loadDriverBusList();

        const time = moment().toDate();
        time.setHours(8);
        time.setMinutes(0);
        time.setSeconds(0);
        time.setMilliseconds(0);
        //const currentTime = time.getTime();
        //const updatedTime = new Date(currentTime * 60 * 60 * 1000);

        //updatedTime.setMinutes(0);

        this.newRoute.timeStart = time;
    },
    methods: {
        async beforeSetupGrid() {
            this.actions.push({
                text: "Filter For Today",
                type: "switch",
                align: "left",
                action: this.onFilterByTodayChanged,
            });

            this.actions.push({
                text: "Actions",
                isMenu: true,
                items: [
                    {
                        value: "copy-season-routes",
                        text: "Copy Season Routes",
                    },
                    {
                        value: "add-group-and-id",
                        text: "Add Group & ID",
                    },
                    {
                        value: "add-Route-Schedule",
                        text: "Add Route Schedule",
                    },
                    {
                        value: "delete-routes",
                        text: "Delete Routes",
                    },
                    {
                        value: "add-route",
                        text: "Add Route",
                    },
                ],
                value: "Actions",
                name: "Actions",
                action: this.openActionModal,
                //showOnSelection: true,
            });

            await this.loadRegID();
            await this.loadTerms();
            await this.loadSeasons();
            await this.loadSeason();

            this.actions.push({
                text: "Select Term",
                type: "select",
                values: this.terms,
                value: this.regID,
                onSelected: this.onTermSelected,
            });

            this.actions.push({
                text: "Select Season",
                type: "select",
                values: this.seasons,
                value: this.season,
                onSelected: this.onSeasonSelected,
            });

            this.url =
                "route?regID=" +
                this.regID +
                "&filterByToday=" +
                this.filterForToday +
                "&season=" +
                this.season;
        },
        openActionModal(option) {
            const selected = this.$refs.grid.getSelectedRowsData();

            if (option != "add-route" && !selected.length) {
                return this.$notify({
                    group: "notification",
                    text: "No Routes Selected",
                    type: "error",
                });
            }

            switch (option) {
                case "copy-season-routes":
                    return this.openCopySeasonRoutes();
                case "add-group-and-id":
                    return this.openGroupAndIdDialog();
                case "add-Route-Schedule":
                    return this.openAddRouteScheduleInBulk();
                case "delete-routes":
                    return this.openDeleteRoutesDialog();
                case "add-route":
                    return this.addRoute();
            }
        },
        onTermSelected(value) {
            this.regID = value;

            this.url =
                "route?regID=" +
                this.regID +
                "&filterByToday=" +
                this.filterForToday +
                "&season=" +
                this.season;

            this.$refs.grid.reloadDataSource(this.url);
        },
        onSeasonSelected(value) {
            this.season = value;

            localStorage.setItem("route-season", value);

            this.url =
                "route?regID=" +
                this.regID +
                "&filterByToday=" +
                this.filterForToday +
                "&season=" +
                this.season;

            this.$refs.grid.reloadDataSource(this.url);
        },
        onFilterByTodayChanged(value) {
            if (value) {
                this.filterForToday = value;

                this.url =
                    "route?regID=" +
                    this.regID +
                    "&filterByToday=true" +
                    "&season=" +
                    this.season;
            } else {
                this.filterForToday = false;

                this.url =
                    "route?regID=" +
                    this.regID +
                    "&filterByToday=" +
                    "&season=" +
                    this.season;
            }

            this.$refs.grid.reloadDataSource(this.url);
        },
        async loadBuildings() {
            const response = await this.$http.get(
                "api/students/getBuildingList",
            );

            response.push("Queens");
            response.push("741");

            this.buildingList = response.sort();
        },
        reloadGrid() {
            this.$refs.grid.reloadGrid();
        },
        async loadGrades() {
            const response = await this.$http.get("api/students/getGradeList");

            response.push("YG");

            this.gradeList = response.sort();
        },
        async loadTerms() {
            const terms = await this.$http.get("api/allStudents/getRegTerms");

            this.terms = terms;
        },
        async loadRegID() {
            this.currentRegID = await this.$http.get(
                "api/allStudents/getRegID",
            );
            this.regID = this.currentRegID;
        },
        async loadSeasons() {
            const seasons = await this.$http.get("api/route/getRouteSeasons");

            this.seasons = seasons.map((s) => s.season);
        },
        async loadSeason() {
            // const season = await this.$http.get(
            //     "api/route/getCurrentRouteSeason",
            // );

            const season = localStorage.getItem("route-season");

            this.season = season ? season : this.seasons[0];
        },
        async loadDriverBusList() {
            const response = await this.$http.get("api/route/getDriverBusList");

            this.driver_busList = response
                .map((driverBus) => {
                    driverBus.displayName =
                        (driverBus.nameH ? driverBus.nameH : driverBus.name) +
                        " - " +
                        driverBus.busNumber;

                    return driverBus;
                })
                .sort((a, b) => a.busNumber - b.busNumber);
        },
        addRoute() {
            this.newRoute.term = this.currentRegID;
            this.newRoute.season = this.season;

            this.newRoute.routeSchedules = [];

            this.addNewRouteDialog = true;

            this.$refs.newDescription.resetValidation();
            this.$refs.newDirection.resetValidation();

            this.addRouteSchedule();
        },
        validateNewRoute() {
            const validations = [
                this.$refs.newDescription.validate(true),
                this.$refs.newDirection.validate(true),
                this.$refs.newRouteIdentifier.validate(true),
                this.$refs.newGroupBy.validate(true),
            ];

            this.$refs.newRouteDriver_bus.map((driver_bus) => {
                validations.push(driver_bus.validate(true));
            });

            // this.$refs.newRouteScheduleType.map((routeScheduleType) => {
            //     validations.push(routeScheduleType.validate(true));
            // });

            return validations.every(Boolean);
        },
        closeAddRouteDialog() {
            this.addNewRouteDialog = false;

            this.newRoute.id = "";
            this.newRoute.term = "";
            this.newRoute.direction = "";
            this.newRoute.color = "";
            this.newRoute.notes = "";
            this.newRoute.routeIdentifier = "";
            this.newRoute.groupBy = "";
            this.newRoute.description = "";
            this.newRoute.buildings = [];
            this.newRoute.grades = [];
            this.newRoute.weekDays = [];
            this.newRoute.routeSchedules = [];
            this.newRoute.goeNotRequired = false;
            this.newRoute.season = "";

            const time = moment().toDate();
            time.setHours(8);
            time.setMinutes(0);
            time.setSeconds(0);
            time.setMilliseconds(0);

            this.newRoute.timeStart = time;
        },
        async saveNewRoute() {
            if (!this.validateNewRoute()) return;

            if (!this.newRoute.buildings.length) {
                return this.$notify({
                    text: "Missing Buildings",
                    group: "notification",
                    type: "error",
                });
            }

            if (!this.newRoute.timeStart) {
                return this.$notify({
                    text: "Missing Time Start",
                    group: "notification",
                    type: "error",
                });
            }

            // if (
            //     this.newRoute.routeSchedules.filter(
            //         (schedule) => schedule.type == "Default",
            //     ).length > 1
            // ) {
            //     return this.$notify({
            //         text: "Can't have more than 1 Default route",
            //         group: "notification",
            //         type: "error",
            //     });
            // }

            const routeSchedules = this.newRoute.routeSchedules
                .filter((r) => r.driver_bus)
                .map((schedule) => {
                    const driver_bus = this.driver_busList.find(
                        (d) => d.displayName == schedule.driver_bus,
                    );

                    return {
                        id: schedule.id,
                        driver_Bus_ID: driver_bus.id,
                        type: schedule.type,
                        term: schedule.term,
                        dateFrom: schedule.dateFrom
                            ? moment(schedule.dateFrom).format("L")
                            : "",
                        dateTo: schedule.dateTo
                            ? moment(schedule.dateTo).format("L")
                            : "",
                    };
                });

            try {
                this.processing = true;

                await this.$http.post("api/route/save", {
                    route: {
                        term: this.newRoute.term,
                        timeStart: this.getTimeStart(this.newRoute.timeStart),
                        direction: this.newRoute.direction,
                        buildings: this.newRoute.buildings.join(","),
                        grades: this.newRoute.grades.join(","),
                        description: this.newRoute.description,
                        weekDays: this.sortWeekdays(
                            this.newRoute.weekDays,
                        ).join(","),
                        color: this.newRoute.color,
                        routeIdentifier: this.newRoute.routeIdentifier,
                        groupBy: this.newRoute.groupBy,
                        notes: this.newRoute.notes,
                        goeNotRequired: this.newRoute.goeNotRequired,
                        season: this.newRoute.season,
                    },
                    routeSchedules,
                });

                this.processing = false;
                this.addNewRouteDialog = false;

                this.newRoute.direction = "";
                this.newRoute.buildings = [];
                this.newRoute.grades = [];
                this.newRoute.description = "";
                this.newRoute.weekDays = [];
                this.newRoute.routeSchedules = [];
                this.newRoute.goeNotRequired = false;

                const time = moment().toDate();
                time.setHours(8);
                time.setMinutes(0);
                time.setSeconds(0);
                time.setMilliseconds(0);

                this.newRoute.timeStart = time;

                this.$notify({
                    group: "notification",
                    text: "Route Saved",
                    type: "success",
                });

                this.$refs.grid.reloadGrid();
            } catch (e) {
                console.log(e);
                this.processing = false;
            }
        },
        sortWeekdays(days) {
            const weekdayOrder = [
                "Sunday",
                "Monday",
                "Tuesday",
                "Wednesday",
                "Thursday",
                "Friday",
                "Saturday",
            ];

            return days.sort(
                (a, b) => weekdayOrder.indexOf(a) - weekdayOrder.indexOf(b),
            );
        },
        async onRowClicked(row) {
            const rowClicked = JSON.parse(JSON.stringify(row));

            rowClicked.buildings = rowClicked.buildings
                ? rowClicked.buildings.split(",")
                : [];
            rowClicked.grades = rowClicked.grades
                ? rowClicked.grades.split(",")
                : [];
            rowClicked.weekDays = rowClicked.weekDays
                ? rowClicked.weekDays.split(",")
                : [];

            let splitTime = rowClicked.timeStart.split(":"); //splitTime = ['06', '10 AM']
            let hour = parseInt(splitTime[0]); //Convert '06' to integer
            let minutes = parseInt(splitTime[1].split(" ")[0]); //Convert '10 AM' to integer

            if (splitTime[1].split(" ")[1] === "PM") {
                //If it is, add 12 hours to the hour variable
                hour += 12;
            }

            const currentDateTime = new Date();

            currentDateTime.setHours(hour);
            currentDateTime.setMinutes(minutes);

            rowClicked.timeStart = currentDateTime;

            await this.loadRouteSchedules(rowClicked);

            // if (!rowClicked.routeSchedules.length) {
            //     this.addRouteSchedule(rowClicked);
            // }

            this.rowClicked = rowClicked;

            this.updateRouteDialog = true;

            this.$forceUpdate();
        },
        closeUpdateRouteDialog() {
            this.updateRouteDialog = false;
        },
        async loadRouteSchedules(rowClicked = null) {
            const response = await this.$http.get(
                "api/route/getRouteSchedules?routeID=" +
                    (rowClicked ? rowClicked.id : this.rowClicked.id),
            );

            const routeSchedules = response.map((routeSchedule) => {
                const driver_bus = this.driver_busList.find(
                    (d) => d.id == routeSchedule.driver_Bus_ID,
                );

                routeSchedule.driver_bus = driver_bus
                    ? driver_bus.displayName
                    : "";

                (routeSchedule.dateFrom = routeSchedule.dateFrom
                    ? toISOLocal(new Date(routeSchedule.dateFrom)).substr(0, 10)
                    : ""),
                    (routeSchedule.dateTo = routeSchedule.dateTo
                        ? toISOLocal(new Date(routeSchedule.dateTo)).substr(
                              0,
                              10,
                          )
                        : ""),
                    (routeSchedule.dateToPickerMenu = false);
                routeSchedule.dateFromPickerMenu = false;

                return routeSchedule;
            });

            if (rowClicked) {
                rowClicked.routeSchedules = routeSchedules;
            } else {
                this.rowClicked.routeSchedules = routeSchedules;
            }

            this.$forceUpdate();
        },
        addRouteSchedule() {
            if (this.addNewRouteDialog) {
                this.newRoute.routeSchedules.push({
                    driver_bus: "",
                    type: "Default",
                    dateFromPickerMenu: false,
                    dateFrom: "",
                    dateToPickerMenu: false,
                    dateTo: "",
                    term: this.currentRegID,
                });
            } else {
                this.rowClicked.routeSchedules.push({
                    driver_bus: "",
                    type: "Default",
                    dateFromPickerMenu: false,
                    dateFrom: "",
                    dateToPickerMenu: false,
                    dateTo: "",
                    term: this.currentRegID,
                });
            }

            this.$forceUpdate();
        },
        removeRouteSchedule(index) {
            // if (this.addNewRouteDialog) {
            //     this.newRoute.routeSchedules.splice(index, 1);

            //     this.$forceUpdate();

            //     return;
            // }

            const obj = this.addNewRouteDialog ? "newRoute" : "rowClicked";

            if (index == 0) {
                this[obj].routeSchedules[index].driver_bus = "";
                this[obj].routeSchedules[index].type = "";
                this[obj].routeSchedules[index].dateFrom = "";
                this[obj].routeSchedules[index].dateTo = "";
            } else {
                this[obj].routeSchedules.splice(index, 1);
            }

            this.$forceUpdate();
        },
        openDeleteRouteSchedule(routeSchedule) {
            this.routeScheduleToDelete = routeSchedule;
            this.routeScheduleDeleteDialog = true;
        },
        editRouteSchedule(routeSchedule) {
            this.routeScheduleToEdit = JSON.parse(
                JSON.stringify(routeSchedule),
            );
            this.routeScheduleEditDialog = true;
        },
        openAddRouteSchedule() {
            this.routeScheduleToAdd = {
                route_ID: this.rowClicked.id,
                driver_bus: "",
                type: "Default",
                dateFromPickerMenu: false,
                dateFrom: "",
                dateToPickerMenu: false,
                dateTo: "",
                term: this.currentRegID,
            };

            this.addRouteScheduleDialog = true;
        },
        openDeleteRoutesDialog() {
            this.selected = this.$refs.grid.getSelectedRowsData();

            this.deleteDialog = true;
        },
        async openAddRouteScheduleInBulk() {
            this.selected = this.$refs.grid.getSelectedRowsData();
            this.addRouteSchedulesInBulk.dateFrom = toISOLocal(
                new Date(),
            ).substr(0, 10);
            this.addRouteSchedulesInBulk.term = this.currentRegID;
            this.addRouteSchedulesInBulkDialog = true;

            await this.loadSelectedRouteSchedules();
        },
        async loadSelectedRouteSchedules() {
            const ids = this.selected.map((s) => s.id);
            const response = await this.$http.post(
                "api/route/getRouteSchedulesForRouteIDs",
                ids,
            );

            this.selected.forEach((route) => {
                route.routeSchedules = JSON.parse(
                    JSON.stringify(
                        response.filter((r) => r.route_ID == route.id),
                    ),
                );

                const currentSchedule = route.routeSchedules.find(
                    (r) => r.id == route.routeScheduleID,
                );

                route.currentSchedule = currentSchedule;

                let driver_bus;

                if (currentSchedule) {
                    driver_bus = this.driver_busList.find(
                        (d) => d.id == currentSchedule.driver_Bus_ID,
                    );
                }

                route.newSchedule = {
                    dateFromPickerMenu: false,
                    dateToPickerMenu: false,
                    dateFrom: "",
                    dateTo: "",
                    driver_bus: driver_bus ? driver_bus.displayName : "",
                };
            });

            this.$forceUpdate();
        },
        async saveRouteSchedulesInBulk() {
            if (!this.addRouteSchedulesInBulk.driver_bus) {
                return this.$notify({
                    group: "notification",
                    text: "Missing Driver / Bus.",
                    type: "error",
                });
            }

            if (!this.addRouteSchedulesInBulk.dateFrom) {
                return this.$notify({
                    group: "notification",
                    text: "Missing start date.",
                    type: "error",
                });
            }

            if (this.isDateFromLater(this.addRouteSchedulesInBulk)) {
                return this.$notify({
                    group: "notification",
                    text: "The start date must be before the end date.",
                    type: "error",
                });
            }

            const isOverlapping = this.selected.some((routeSchedule) => {
                return this.isOverlapping(
                    routeSchedule.routeSchedules,
                    this.addRouteSchedulesInBulk,
                );
            });

            if (isOverlapping) {
                return this.$notify({
                    group: "notification",
                    text:
                        "There is another active schedule for the selected dates, please adjust.",
                    type: "error",
                });
            }

            try {
                this.processing = true;

                const list = this.selected.map((route) => {
                    const data = JSON.parse(
                        JSON.stringify(this.addRouteSchedulesInBulk),
                    );

                    const driver_bus = this.driver_busList.find(
                        (d) =>
                            d.displayName ==
                            this.addRouteSchedulesInBulk.driver_bus,
                    );

                    data.driver_Bus_ID = driver_bus.id;
                    data.route_ID = route.id;

                    delete data.driver_bus;

                    return data;
                });

                await this.$http.post(
                    "api/route/saveRouteSchedulesInBulk",
                    list,
                );

                this.addRouteSchedulesInBulkDialog = false;

                this.processing = false;

                this.$notify({
                    group: "notification",
                    text: "Changes Saved",
                    type: "success",
                });

                this.$refs.grid.reloadGrid();
            } catch (e) {
                console.log(e);
                this.processing = false;
            }
        },
        async deleteRoutes() {
            try {
                const ids = this.selected.map((s) => s.id);

                this.processing = true;

                await this.$http.post("api/route/delete", ids);

                this.processing = false;
                this.deleteDialog = false;

                this.$notify({
                    group: "notification",
                    text: ids.length + " Routes Deleted",
                    type: "success",
                });

                this.$refs.grid.reloadGrid();
            } catch (e) {
                this.processing = false;
            }
        },
        formatedDate(date) {
            return date ? moment(date).format("L") : "";
        },
        validate() {
            const validations = [
                this.$refs.description.validate(true),
                this.$refs.direction.validate(true),
            ];

            // this.$refs.driver_bus.map((driver_bus) => {
            //     validations.push(driver_bus.validate(true));
            // });

            // this.$refs.routeScheduleType.map((routeScheduleType) => {
            //     validations.push(routeScheduleType.validate(true));
            // });

            return validations.every(Boolean);
        },
        async saveRoute() {
            if (!this.validate()) return;

            if (
                this.rowClicked.routeSchedules.some(
                    (schedule) =>
                        schedule.dateFrom &&
                        schedule.dateTo &&
                        new Date(schedule.dateFrom) > new Date(schedule.dateTo),
                )
            ) {
                return this.$notify({
                    text: "From Date is later than the To Date",
                    group: "notification",
                    type: "error",
                });
            }

            // if (
            //     this.rowClicked.routeSchedules.filter(
            //         (schedule) => schedule.type == "Default",
            //     ).length > 1
            // ) {
            //     return this.$notify({
            //         text: "Can't have more than 1 Default route",
            //         group: "notification",
            //         type: "error",
            //     });
            // }

            try {
                this.processing = true;

                const routeSchedules = this.rowClicked.routeSchedules
                    .filter((r) => r.driver_bus)
                    .map((schedule) => {
                        const driver_bus = this.driver_busList.find(
                            (d) => d.displayName == schedule.driver_bus,
                        );

                        return {
                            id: schedule.id,
                            driver_Bus_ID: driver_bus.id,
                            type: schedule.type,
                            term: schedule.term,
                            dateFrom: schedule.dateFrom
                                ? moment(schedule.dateFrom).format("L")
                                : "",
                            dateTo: schedule.dateTo
                                ? moment(schedule.dateTo).format("L")
                                : "",
                        };
                    });

                await this.$http.post("api/route/save", {
                    route: {
                        id: this.rowClicked.id,
                        term: this.rowClicked.term,
                        timeStart: this.getTimeStart(this.rowClicked.timeStart),
                        direction: this.rowClicked.direction,
                        buildings: this.rowClicked.buildings.join(","),
                        grades: this.rowClicked.grades.join(","),
                        description: this.rowClicked.description,
                        weekDays: this.sortWeekdays(
                            this.rowClicked.weekDays,
                        ).join(","),
                        color: this.rowClicked.color,
                        notes: this.rowClicked.notes,
                        routeIdentifier: this.rowClicked.routeIdentifier,
                        groupBy: this.rowClicked.groupBy,
                        goeNotRequired: this.rowClicked.goeNotRequired,
                    },
                    routeSchedules,
                });

                this.$notify({
                    group: "notification",
                    text: "Changes Saved",
                    type: "success",
                });

                this.updateRouteDialog = false;
                this.processing = false;

                this.$refs.grid.reloadGrid();
            } catch (e) {
                console.log(e);
                this.processing = false;
            }
        },
        openGroupAndIdDialog() {
            this.selected = this.$refs.grid.getSelectedRowsData();
            this.updateGroupAndIdDialog = true;
        },
        async openCopySeasonRoutes() {
            this.selected = this.$refs.grid.getSelectedRowsData();

            await this.loadSelectedRouteSchedules();

            this.copyRoutesDialog = true;

            this.$forceUpdate();
        },
        closeCopyRoutesDialog() {
            this.copyRoutesDialog = false;
        },
        async saveGroupAndID() {
            try {
                this.processing = true;

                await this.$http.post("api/route/saveGroupAndID", {
                    ids: this.selected.map((s) => s.id),
                    routeIdentifier: this.routeIdentifier,
                    groupBy: this.groupBy,
                });

                this.$notify({
                    group: "notification",
                    text: "Changes Saved",
                    type: "success",
                });

                this.updateGroupAndIdDialog = false;
                this.processing = false;

                this.$refs.grid.reloadGrid();
            } catch (e) {
                console.log(e);
            }
        },
        getTimeStart(value) {
            var date = new Date(value);
            var hour = date.getHours();
            var minutes = date.getMinutes();

            // Convert to 12-hour clock
            var period = hour >= 12 ? "PM" : "AM";
            hour = hour > 12 ? hour - 12 : hour;
            hour = hour === 0 ? 12 : hour;

            // Format minutes
            if (minutes < 10) {
                minutes = "0" + minutes;
            }

            return hour + ":" + minutes + " " + period;
        },
        isOverlapping(routeSchedules, scheduleToEdit) {
            for (let i = 0; i < routeSchedules.length; i++) {
                // check if scheduleToEdit date range overlaps with any other schedule
                if (
                    scheduleToEdit.dateFrom >= routeSchedules[i].dateFrom &&
                    scheduleToEdit.dateFrom < routeSchedules[i].dateTo &&
                    routeSchedules[i].dateTo !== null
                ) {
                    // scheduleToEdit overlaps with this schedule, return true
                    return true;
                }
                if (
                    scheduleToEdit.dateTo !== null &&
                    scheduleToEdit.dateTo >= routeSchedules[i].dateFrom &&
                    scheduleToEdit.dateTo < routeSchedules[i].dateTo
                ) {
                    // scheduleToEdit overlaps with this schedule, return true
                    return true;
                }
                // check if any other schedules has a null dateTo - meaning it runs till end of time
                if (
                    scheduleToEdit.dateTo === null &&
                    routeSchedules[i].dateTo === null
                ) {
                    // overlapping as both schedules run till end of time
                    return true;
                }
            }

            // if no overlaps, return false
            return false;
        },
        isDateFromLater(routeSchedule) {
            if (!routeSchedule.dateTo) return;

            if (routeSchedule.dateFrom > routeSchedule.dateTo) {
                return true;
            } else {
                return false;
            }
        },
        async saveRouteSchedule({ routeSchedule }) {
            if (!routeSchedule.driver_bus) {
                return this.$notify({
                    group: "notification",
                    text: "Missing Driver / Bus.",
                    type: "error",
                });
            }

            if (!routeSchedule.dateFrom) {
                return this.$notify({
                    group: "notification",
                    text: "Missing start date.",
                    type: "error",
                });
            }

            if (this.isDateFromLater(routeSchedule)) {
                return this.$notify({
                    group: "notification",
                    text: "The start date must be before the end date.",
                    type: "error",
                });
            }

            if (
                this.isOverlapping(
                    this.rowClicked.routeSchedules.filter(
                        (r) => r.id != routeSchedule.id,
                    ),
                    routeSchedule,
                )
            ) {
                return this.$notify({
                    group: "notification",
                    text:
                        "There is another active schedule for the selected dates, please adjust.",
                    type: "error",
                });
            }

            try {
                this.processing = true;

                const data = JSON.parse(JSON.stringify(routeSchedule));

                const driver_bus = this.driver_busList.find(
                    (d) => d.displayName == routeSchedule.driver_bus,
                );

                data.driver_Bus_ID = driver_bus.id;

                delete data.driver_bus;

                await this.$http.post("api/route/saveRouteSchedule", data);

                this.routeScheduleEditDialog = false;
                this.addRouteScheduleDialog = false;

                this.processing = false;

                this.loadRouteSchedules();

                this.$notify({
                    group: "notification",
                    text: "Changes Saved",
                    type: "success",
                });

                this.$refs.grid.reloadGrid();
            } catch (e) {
                this.processing = false;
            }
        },
        async deleteRouteSchedule() {
            try {
                this.processing = true;

                await this.$http.post(
                    "api/route/deleteRouteSchedule?id=" +
                        this.routeScheduleToDelete.id,
                );

                this.routeScheduleDeleteDialog = false;

                this.processing = false;

                this.loadRouteSchedules();

                this.$notify({
                    group: "notification",
                    text: "Route Schedule Deleted",
                    type: "success",
                });

                this.$refs.grid.reloadGrid();
            } catch (e) {
                this.processing = false;
            }
        },
    },
};
</script>
<style>
.gray-fg {
    color: #999;
}
.toggle-button {
    font-size: 15px;
    padding: 5px !important;
}
.toggle-button-group {
    border-radius: 10px;
}
.toggle-button-group.v-btn-toggle .v-btn.v-btn--active {
    background-color: #afecb2 !important;
    color: #4caf50 !important;
}
.toggle-button-group.v-btn-toggle .v-btn.v-btn--active.default-schedule-button {
    border-radius: 10px 0px 0px 10px;
}
.toggle-button-group.v-btn-toggle .v-btn.v-btn--active.sub-schedule-button {
    border-radius: 0px 10px 10px 0px;
}
</style>
